import Swal from 'sweetalert2';
import { authHeader } from './authHeader';
import { Fragment } from 'react';
import ReactDOM from 'react-dom';
import Loader from '../Components/Loader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Preguntas_frecuentes = {
    agregarPregunta: async (data) => {
        ReactDOM.render(
            <div className='loader_padre'>
                <Loader />
            </div>,
            document.getElementById("loader_padre")
        );

        let url = url_json + "/pregunta-frecuente"
        let body = {
            pregunta: data.pregunta,
            respuesta: data.respuesta,
            campo: data.campo
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();

        ReactDOM.render(
            <Fragment></Fragment>,
            document.getElementById("loader_padre")
        );

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Pregunta agregada correctamente' ,
              'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar la pregunta, codigo: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerPreguntas: async () => {
        let url = url_json + "/pregunta-frecuente"
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerUnaPregunta: async id => {
        let url = url_json + "/pregunta-frecuente/" + id
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarPregunta: async (data, id) => {
        return Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea modificar la pregunta?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                ReactDOM.render(
                    <div className='loader_padre'>
                        <Loader />
                    </div>,
                    document.getElementById("loader_padre")
                );

                let url = url_json + "/pregunta-frecuente/" + id;

                let body = {
                    pregunta: data.pregunta,
                    respuesta: data.respuesta,
                    campo: data.campo
                };
                let request = {
                    method: 'PATCH',
                    body: JSON.stringify(body),
                    headers: authHeader()
                }

                let response = await fetch(url, request);
                let res = await response.json();

                ReactDOM.render(
                    <Fragment></Fragment>,
                    document.getElementById("loader_padre")
                );

                if (response.ok) {
                    Swal.fire(
                        'Modificación exitosa!',
                        'Pregunta modificada correctamente' ,
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudo modificar la pregunta' ,
                        'error'
                    )
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Modificación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        });
    },
    eliminarPregunta: async id => {
        return Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea eliminar la pregunta?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                ReactDOM.render(
                    <div className='loader_padre'>
                        <Loader />
                    </div>,
                    document.getElementById("loader_padre")
                );

                let url = url_json + "/pregunta-frecuente/delete/" + id;
                let request = {
                    method: 'PATCH',
                    headers: authHeader()
                }

                let response = await fetch(url, request);
                let res = await response.json();

                ReactDOM.render(
                    <Fragment></Fragment>,
                    document.getElementById("loader_padre")
                );

                if (response.ok) {
                    Swal.fire(
                        'Eliminación exitosa!',
                        'Pregunta eliminada correctamente' ,
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudo eliminar la pregunta' ,
                        'error'
                    )
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Eliminación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        })
    }
}

export default Preguntas_frecuentes;
